import { c as _c } from "react/compiler-runtime";
import { classNames, FlexCenter, Spinner, TextLabel } from "@opensea/ui-kit";
import { Check, ErrorFilled } from "@opensea/ui-kit/icons";
export function WalletStatusIndicator(t0) {
  const $ = _c(20);
  const {
    state,
    children,
    onClick
  } = t0;
  const t1 = state === "pending";
  const t2 = state === "complete";
  const t3 = state === "error";
  const t4 = Boolean(onClick);
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = classNames("h-8 gap-2 rounded-md px-3 py-1", {
      "bg-rare-transparent-1 text-rare": t1,
      "bg-success-1-transparent-1 text-success-1": t2,
      "bg-error-1-transparent-1 text-error-1": t3,
      "cursor-pointer": t4
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== state) {
    t6 = state === "pending" && <Spinner className="fill-rare" size="xs" />;
    $[5] = state;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== state) {
    t7 = state === "complete" && <Check size={16} />;
    $[7] = state;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== state) {
    t8 = state === "error" && <ErrorFilled size={16} />;
    $[9] = state;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== children) {
    t9 = <TextLabel>{children}</TextLabel>;
    $[11] = children;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== onClick || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = <FlexCenter className={t5} onClick={onClick}>{t6}{t7}{t8}{t9}</FlexCenter>;
    $[13] = onClick;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}